interface CallToActionSectionProps {
  onWhatsAppClick: () => void;
}

export default function CallToActionSection({ onWhatsAppClick }: CallToActionSectionProps) {
  return (
    <section className="py-16 bg-gradient-to-r from-green-600 to-green-700">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Faça seu Orçamento!</h2>
        <p className="text-base md:text-lg text-green-100 mb-6 max-w-2xl mx-auto">
          Compare estrutura e atendimento. Atendimento rápido e direto via WhatsApp com DJ Jean!
        </p>
        <div className="flex justify-center">
          <button 
            onClick={onWhatsAppClick}
            className="bg-white text-green-600 hover:bg-gray-100 px-8 py-4 rounded-full text-lg font-bold transition-all transform hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap flex items-center"
          >
            <i className="ri-whatsapp-line mr-2"></i>
            Falar com DJ Jean
          </button>
        </div>
      </div>
    </section>
  );
}